import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { PiGoogleLogo } from 'react-icons/pi';
import AuthLayout from '../components/AuthLayout';
import { PasswordField, TextField } from '../components/FormFields';
import { auth } from '../firebaseConfig';
import { getInviteTokenFromLocation, rememberPendingInvite, signInWithGoogle } from '../services/authService';
import { OFFLINE_REQUIRED, requireConnectionForMutation } from '../services/connectivityService';
import './login.css';

const getAuthMessage = (error) => {
  if (error.code === OFFLINE_REQUIRED) return 'Esta operação exige conexão. Conecte-se e tente novamente.';
  if (error.code === 'auth/invalid-credential') return 'E-mail ou senha inválidos.';
  if (error.code === 'auth/popup-closed-by-user' || error.code === 'auth/cancelled-popup-request') return 'Login com Google cancelado.';
  if (error.code === 'auth/account-exists-with-different-credential') return 'Já existe uma conta com este e-mail. Entre usando o método original.';
  return 'Não foi possível entrar. Tente novamente.';
};

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [inviteToken, setInviteToken] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const token = getInviteTokenFromLocation();
    setInviteToken(token);
    rememberPendingInvite(token);
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);
    try {
      requireConnectionForMutation();
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/dashboard');
    } catch (loginError) {
      setError(getAuthMessage(loginError));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError('');
    setIsSubmitting(true);
    try {
      const result = await signInWithGoogle({ inviteToken });
      if (!result.redirected) navigate('/dashboard');
    } catch (googleError) {
      setError(getAuthMessage(googleError));
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout title="Bem-vindo" subtitle="Acesse sua conta para continuar.">
      <button className="auth-google-button" type="button" onClick={handleGoogleLogin} disabled={isSubmitting}>
        <PiGoogleLogo size={20} aria-hidden="true" />
        Continuar com Google
      </button>
      <div className="auth-divider"><span>ou use seu e-mail</span></div>
      <form className="auth-form" onSubmit={handleLogin}>
        {error && <div className="auth-alert auth-alert--error" role="alert">{error}</div>}
        <TextField id="login-email" label="E-mail" type="email" inputMode="email" autoComplete="email" value={email} onChange={setEmail} required disabled={isSubmitting} />
        <PasswordField id="login-password" label="Senha" value={password} onChange={setPassword} required disabled={isSubmitting} />
        <button className="auth-primary-button" type="submit" disabled={isSubmitting}>{isSubmitting ? 'Entrando…' : 'Entrar'}</button>
        <Link className="auth-forgot-link" to="/forgot-password">Esqueceu sua senha?</Link>
      </form>
      <p className="auth-switch">Ainda não tem uma conta? <Link to={`/register${inviteToken ? `?invite=${inviteToken}` : ''}`}>Criar conta</Link></p>
    </AuthLayout>
  );
};

export default Login;
